import { useMutation } from "@tanstack/react-query";
import type { RecipeImportDraft } from "@batch-and-bowl/shared";
import {
  extractRecipeFromImage,
  extractRecipeFromUrl,
} from "../api/recipe-import";
import { track } from "../analytics";
import { analyticsFailure } from "../analytics-failures";

export type ExtractRecipeInput = { url: string } | { file: File };

export function useExtractRecipe() {
  return useMutation<RecipeImportDraft, Error, ExtractRecipeInput>({
    mutationFn: (input) =>
      "url" in input
        ? extractRecipeFromUrl(input.url)
        : extractRecipeFromImage(input.file),
    // `source` is the draft's extractionMethod ("jsonld" | "llm") -- the path
    // the API actually took. Nothing else from the draft is safe to send: the
    // pasted URL, sourceName, title and instructions are all user or
    // third-party content.
    onSuccess: (draft) => {
      track("recipe_imported", { source: draft.extractionMethod });
    },
    onError: (error) => {
      track("recipe_import_failed", analyticsFailure(error, "import"));
    },
  });
}
